// Pure build-version formatting shared by the web footer and (conceptually) any
// other surface that needs to show which build is running. No I/O — the raw
// values (build date, last PR number) are injected at build time.

export interface BuildInfo {
  /** ISO date the bundle was built, e.g. "2026-06-30". */
  readonly buildDate: string;
  /** Number of the last merged PR, as a string or number. */
  readonly lastPr: string | number;
}

/**
 * Render a compact build label, e.g. `2026-06-30 · #33`.
 * Falls back gracefully when values are missing (local/dev builds).
 */
export function formatBuildLabel(info: BuildInfo): string {
  const date = String(info.buildDate ?? '').trim() || 'dev';
  const pr = String(info.lastPr ?? '').trim();
  return pr ? `${date} · #${pr}` : date;
}
